import React from "react";

import { format } from "date-fns";
import { useTranslation } from "react-i18next";

import { BaseCard } from "components/BaseCard";
import { StatusBadge } from "components/StatusBadge";
import { TitleSubTitleLabel } from "components/TitleSubTitleLabel";

import record from "assets/svg/recnothing.svg";

import { IRecordCard } from "./interface";
import {
  Container,
  RightContainer,
  DurationContainer,
  DurationText,
  LeftSide,
  TitleColumn,
} from "./styles";

const RecordCard: React.FC<IRecordCard> = ({
  title,
  subTitle,
  labelStatus,
  type,
  date,
  duration,
  selected = false,
  onClick,
  disabled = false,
  isExternal = false,
}) => {
  const { t } = useTranslation();

  const handleClick = () => {
    if (!disabled && onClick) {
      onClick();
    }
  };

  return (
    <BaseCard selected={selected} disabled={disabled} onClick={handleClick}>
      <Container disabled={disabled}>
        <LeftSide>
          <img src={record} />
          <TitleColumn>
            <TitleSubTitleLabel
              childrenTitle={title}
              childrenSubTitle={subTitle}
              marginTop="4px"
            />
            {isExternal && (
              <StatusBadge
                id="external_video_badge"
                label={t("recordings.externalVideo")}
                type="inactive"
              />
            )}
          </TitleColumn>
        </LeftSide>
        <RightContainer>
          {date ? <strong>{format(date, "dd/MM/yyyy")}</strong> : null}
          {/* <DurationContainer>
            <DurationText>{duration}</DurationText>
          </DurationContainer> */}
          <StatusBadge id="status_badge" label={labelStatus} type={type} />
        </RightContainer>
      </Container>
    </BaseCard>
  );
};

export default RecordCard;
